// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__29Mh-","actionsCol":"EnrolledClinics_actionsCol__32hjC"};